import { render, staticRenderFns } from "./CardProductReturn.vue?vue&type=template&id=734335f2&"
import script from "./CardProductReturn.vue?vue&type=script&lang=js&"
export * from "./CardProductReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports